




























import { Component } from 'nuxt-property-decorator'
import ModalTree from '~/components/experience/destinations-category-tree/desktop/modal-tree.vue'
import TreeModel from '~/components/experience/destinations-category-tree/desktop/tree-model'

@Component({
  components: {
    ModalTree
  }
})

export default class DesktopTreeModal extends TreeModel {
}
